module.exports = __webpack_public_path__ + "static/media/sign_in_background.4fb0818a.png";